import { useEffect } from 'react';

import { useAppSelector } from '@/shared/hooks';

import { composedModel } from '@/entities/composed';

import type { ToothSliceSource, ToothSliceSourceState } from '../config';
import {
  resolveToothSliceSourceState,
  rememberToothSliceGeometry,
} from '../lib';

import { useResolvedToothID } from './useResolvedToothID';

export const useToothSliceSourceState = (
  toothID?: string,
): ToothSliceSourceState => {
  const contextToothID = useResolvedToothID(toothID);

  const toothSliceContext = useAppSelector(
    composedModel.selectors.selectToothSliceContext(contextToothID),
  );

  const state = resolveToothSliceSourceState(toothSliceContext);
  const { source } = state;

  useEffect(() => {
    if (source?.kind === 'tooth') {
      rememberToothSliceGeometry(source);
    }
  }, [source]);

  return state;
};

export const useToothSliceSource = (
  toothID?: string,
): ToothSliceSource | null => useToothSliceSourceState(toothID).source;
